import { AuthenticationService } from '../../services/authentication.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataexchangeService } from '../../services/dataexchange.service';
import { Router } from '@angular/router';
import { SocketService } from '../../services/SocketService';
import { StateService } from '../../services/state.service';
import { UserService } from '../../services/user.service';
import { MatchBoardState } from '../../store/state/reducers/matchboard.reducers';
import { Store } from '@ngrx/store';
import { SelectOnBehalfUser, UpdateGraphData } from '../../store/state/actions/matchboard.actions';
import { SelectOnBehalfUserAction } from '../../models/SelectOnBehalfUserAction';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatchPasswordValidator } from '../../helpers/matchpassword.validator';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Role } from '../../models/role';
import { UpdateStaticInfoWidgetComponent } from '@baxter-jenkins/update-static-info-widget';
import { SecuritySettingsComponent } from '@clearing-hub/angular-common';

export class Lang {
  name: string;
  abbrev: string;

  constructor(name: string, abbrev: string) {
    this.name = name;
    this.abbrev = abbrev;
  }
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input()
  onBehalfUsers: any[];

  @ViewChild('settingsTemplate')
  settingsTemplate: any;

  selectedUser: string;

  isCollapsed = true;
  isSuperUser: boolean;

  languages: Lang[];

  selectedLang: any;

  modalRef: BsModalRef;

  passform: FormGroup;

  isOpen = true;

  passChangeMessage = '';

  subscriptions: Subscription[] = [];

  notFocused = false;

  constructor(private readonly authenticationService: AuthenticationService,
              private readonly router: Router,
              private readonly userService: UserService,
              private readonly dataexchangeService: DataexchangeService,
              private readonly stateService: StateService,
              private readonly socketService: SocketService,
              private readonly store: Store<MatchBoardState>,
              private readonly modalService: BsModalService,
              private readonly translateService: TranslateService,
              private readonly formBuilder: FormBuilder,
              private readonly toastrService: ToastrService) {
  }

  ngOnInit() {
    this.userService.getUserRole() === Role.RL_SUPER_USER ? this.isSuperUser = true : this.isSuperUser = false;
    this.languages = [
      new Lang('hu', 'HU_hu'),
      new Lang('en', 'EN_en')
    ];

    this.selectedLang = new Lang('English', 'EN_en');

    this.passform = this.formBuilder.group({
        oldPassword: ['', Validators.required],
        newPassword: ['', [Validators.required]],
        newPasswordconf: ['', Validators.required]
      },
      {
        validator: MatchPasswordValidator.validate.bind(this)
      }
    );
  }

  submitPassChange() {
    this.subscriptions.push(
      this.userService.changePassword({oldPassword: this.passform.value.oldPassword, newPassword: this.passform.value.newPassword}).subscribe(() => {
        this.toastrService.success('Success');
        this.modalRef.hide();
        this.passform.reset();
      }, err => {
        this.passChangeMessage = err.error;
      })
    );
  }

  changeBehalfUser() {
    this.dataexchangeService.setSelectedOnBehalfUser(this.selectedUser);
    this.userService.findSpecificClientState(this.selectedUser).subscribe((state: any) => {
      this.dataexchangeService.setTabs(state.tabs);
      this.store.dispatch(new SelectOnBehalfUser(new SelectOnBehalfUserAction(state.orders, state.swapHistory, state.trades, this.selectedUser, state.abosPositions)));
      this.store.dispatch(new UpdateGraphData(state.graphData));
    });
  }

  logout() {
    this.socketService.disconnectUser();
    this.authenticationService.logout().subscribe(() => {
      this.dataexchangeService.resetObservablesToDefaultValue();
      this.socketService.disconnectUser();
      localStorage.removeItem('currentUser');
      this.router.navigateByUrl('login');
    }, err => {
      this.socketService.disconnectUser();
      localStorage.removeItem('currentUser');
      this.router.navigateByUrl('login');
    });
  }

  openSettings() {
    const initialState = {
      toastr: this.toastrService,
      includeModal: true
    }
    this.modalRef = this.modalService.show(SecuritySettingsComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true,  // enable Esc
      class: 'modal-lg',
      initialState
    });
    this.modalRef.content.cancelEvent.subscribe(() => {
      this.modalRef.hide();
    })
  }

  switchLanguage(language: string) {
    this.setLang(language);
    this.selectedLang = this.languages.find((elm) => {
      return elm.abbrev === language;
    });
    // storeLocaleLang(this.selectedLang.abbrev);
    this.dataexchangeService.changeLanguage(language);
  }

  public setLang(language: string): void {
    this.translateService.use(language).subscribe(() => {
      this.dataexchangeService.changeLanguage(language);
    });
    // this.datepickerLocaliseService.setDatePickerlang();
  }

  openEditStaticInfo() {
    this.modalRef = this.modalService.show(UpdateStaticInfoWidgetComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true,
      class: 'modal-md'
    });

    this.modalRef.content.cancelEvent.subscribe(() => {
      this.modalRef.hide();
    })
    this.modalRef.content.updateResultEvent.subscribe(() => {
      this.modalRef.hide();
      this.toastrService.success('Company successfully modified');
    })
  }
}
